angular.module('Const').constant('shipmentSelectsConsts', {
    'shipmentStatuses': {
        'new': 'New',
        'unprocessed': 'Unprocessed',
        'inProgress': 'Processing',
        'pending': 'Awaiting Booking',
        'processed': 'Completed'
    },
    'packagesTypes': [
        'Carton',
        'Skid',
        'Cage',
        'Pallet',
        'Unit Load Device (ULD)',
        'Container',
        'Other'
    ],
    'ReasonForExport': [
        {
            text: 'Purchase',
            value: 'purchase'
        }, {
            text: 'Gift',
            value: 'gift'
        },{
            text: 'Sale',
            value: 'sale'
        },{
            text: 'Sample',
            value: 'sample'
        },{
            text: 'Return',
            value: 'return'
        },{
            text: 'Repair',
            value: 'repair'
        },{
            text: 'Personal Effects',
            value: 'personalEffects'
        }
    ],
    'TaxStatus': ['private'],
    'UNITS': {
        weight: [
            // {
            //     value: 'Grams',
            //     full: 'Grams',
            //     short: 'g'
            // },
            {
                value: 'Kilograms',
                full: 'KG',
                short: 'kg'
            },
            // {
            //     value: 'Ounces',
            //     full: 'Ounces',
            //     short: 'oz'
            // },
            {
                value: 'Pounds',
                full: 'LBS',
                short: 'lbs'
            }
        ],
        measure: [
            {
                value: 'CM',
                full: 'CM',
                short: 'cm'
            },
            // {
            //     value: 'M',
            //     full: 'Meters',
            //     short: 'm'
            // },
            {
                value: 'IN',
                full: 'IN',
                short: 'in'
            },
            // {
            //     value: 'FT',
            //     full: 'Feet',
            //     short: 'ft'
            // }
        ],
        units: {
            Grams: {
                name: 'Grams',
                short: 'G'
            },
            Kilograms: {
                name: 'Kilograms',
                short: 'KG'
            },
            Ounces: {
                name: 'Ounces',
                short: 'OZ'
            },
            Pounds: {
                name: 'Pounds',
                short: 'LBS'
            },
            Centimeters: {
                name: 'Centimeters',
                short: 'CM'
            },
            Meters: {
                name: 'Meters',
                short: 'M'
            },
            Inches: {
                name: 'Inches',
                short: 'IN'
            },
            Feet: {
                name: 'Feet',
                short: 'FT'
            },
            G: {
                name: 'Grams',
                short: 'G'
            },
            KG: {
                name: 'Kilograms',
                short: 'KG'
            },
            OZ: {
                name: 'Ounces',
                short: 'OZ'
            },
            LBS: {
                name: 'Pounds',
                short: 'LBS'
            },
            CM: {
                name: 'Centimeters',
                short: 'CM'
            },
            M: {
                name: 'Meters',
                short: 'M'
            },
            IN: {
                name: 'Inches',
                short: 'IN'
            },
            FT: {
                name: 'Feet',
                short: 'FT'
            },
            grams: {
                name: 'Grams',
                short: 'G'
            },
            kilograms: {
                name: 'Kilograms',
                short: 'KG'
            },
            ounces: {
                name: 'Ounces',
                short: 'OZ'
            },
            pounds: {
                name: 'Pounds',
                short: 'LBS'
            },
            centimeters: {
                name: 'Centimeters',
                short: 'CM'
            },
            meters: {
                name: 'Meters',
                short: 'M'
            },
            inches: {
                name: 'Inches',
                short: 'IN'
            },
            feet: {
                name: 'Feet',
                short: 'FT'
            },
            g: {
                name: 'Grams',
                short: 'G'
            },
            kg: {
                name: 'Kilograms',
                short: 'KG'
            },
            oz: {
                name: 'Ounces',
                short: 'OZ'
            },
            lbs: {
                name: 'Pounds',
                short: 'LBS'
            },
            cm: {
                name: 'Centimeters',
                short: 'CM'
            },
            m: {
                name: 'Meters',
                short: 'M'
            },
            in: {
                name: 'Inches',
                short: 'IN'
            },
            ft: {
                name: 'Feet',
                short: 'FT'
            }
        },
        combined: [
            //Grams, Kilograms, Ounces, Pounds
            // {
            //     values: {
            //         measureUnit: 'CM',
            //         weightUnit: 'Grams',
            //         weightUnitLong: 'Grams'
            //     },
            //     full: 'Centimeters / Grams',
            //     short: 'cm',
            //     weightShort : 'g'
            // },
            {
                values: {
                    measureUnit: 'CM',
                    weightUnit: 'Kilograms',
                    weightUnitLong: 'Kilograms'
                },
                full: 'Kilograms / Centimeters',
                label: 'KG / CM',
                short: 'cm',
                weightShort : 'kg'
            },
            {
                values: {
                    measureUnit: 'IN',
                    weightUnit: 'Pounds',
                    weightUnitLong: 'Pounds'
                },
                label: 'LBS / IN',
                full: 'Pounds / Inches',
                short: 'in',
                weightShort : 'lbs'
            }
        ]
    }
});



// WEBPACK FOOTER //
// ./js/consts/quote-and-book.js